(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layered-slideshow"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const AUTOPLAY_INTERVAL = 5000;

    class LayeredSlideshowAutoplay {
      constructor(section) {
        this.section = section;
        this.tabs = Array.from(section.querySelectorAll('[role="tab"]'));
        this.currentIndex = 0;
        this.timer = null;

        if (this.tabs.length < 2) return;

        this.start();

        section.addEventListener('mouseenter', () => this.stop());
        section.addEventListener('mouseleave', () => this.start());
        section.addEventListener('touchstart', () => this.stop(), { passive: true });

        this.tabs.forEach((tab, i) => {
          tab.addEventListener('click', () => {
            this.currentIndex = i;
            this.stop();
            this.start();
          });
        });
      }

      start() {
        this.stop();
        this.timer = setInterval(() => this.advance(), AUTOPLAY_INTERVAL);
      }

      stop() {
        clearInterval(this.timer);
      }

      advance() {
        this.currentIndex = (this.currentIndex + 1) % this.tabs.length;
        this.tabs[this.currentIndex].click();
      }
    }

    document.querySelectorAll('layered-slideshow-component').forEach(el => {
      new LayeredSlideshowAutoplay(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
